export { default } from "./YesNoTag";
